import { render, staticRenderFns } from "./CreateInvoiceConsultation.vue?vue&type=template&id=5d45b89a"
import script from "./CreateInvoiceConsultation.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceConsultation.vue?vue&type=script&lang=js"
import style0 from "./CreateInvoiceConsultation.vue?vue&type=style&index=0&id=5d45b89a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports